import { NavigationService } from './shared/services/navigation/navigation-service.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { ApplicationService } from './shared/services/application/application.service';
import { getValueProperty } from './shared/helpers/functions.helpers';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  previousHeight: number = 0;
  frameEl?: any = frameElement;

  constructor(
    private _navigator: NavigationService,
    private _appService: ApplicationService
  ) { }

  ngOnInit(): void {
    this._navigator.loadApplicationFlow();
    this._appService.initSettings()
      .finally(async () => {
        await this._appService.initRecaptcha();
        await this._appService.initAnalytics();
      });
  }

  @HostListener("window:load")
  onLoad() {
    let elementApp = document.querySelector("html");
    //let elementModal = document.querySelector("div.cdk-global-overlay-wrapper");
    const resizeObject = new ResizeObserver(this.callbackFn);
    if (elementApp) {
      resizeObject.observe(elementApp);
    }
  }

  callbackFn = (entries: any) => {
    // since we are observing only a single element, so we access the first element in entries array
    let rect = getValueProperty(entries, '0.contentRect');
    // current width & height
    let height = getValueProperty(rect, 'height');
    this.previousHeight = this.frameEl?.height;
    if (this.frameEl) {
      this.frameEl.height = height;
      let elementApp = document.querySelector("html");
      if(elementApp){
        elementApp.style.overflow = 'hidden';
      }
      
    }
  }

}
